import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import {FormattedMessage, injectIntl} from "react-intl";

import CheckBox from './../../../common/checkBox';
import Analytics from './../../../../analytics';
import {
  setExpandedFilters,
  setFilterVisible,
  setSelectedFilters,
  showFilters
} from "../../../../actions/actionFunctions";
// import FilterSelection from "./filterSelection";
import FiltersSearch from "./filtersSearch";
import NavigationRequests from "../navigationRequests";

const toggleArrayValue = (array, value) => {
  let index = array.indexOf(value);
  (index >= 0) ? array.splice(index, 1) : array.push(value);
  return array;
};

export const toggleFilterArrayValue = (array, {filterId, filterGroupId}) => {
  let index = findIndex(array, {filterId});
  if (index >= 0) {
    array.splice(index, 1);
  } else {
    array.push({filterId, filterGroupId});
  }
  return array;
};

const arrayHasValue = (array, value) => {
  return (array.indexOf(value) >= 0);
};

class FiltersBody extends NavigationRequests {
  static propTypes = {
    id: PropTypes.string.isRequired,
    searchText: PropTypes.string.isRequired,
    handleSearchInputChange: PropTypes.func.isRequired,
    childItem: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      filterButtons: ["Others", "Materials", "Brand", "Color"]
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.setAvailableFiltersValues();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setAvailableFiltersValues() {
    const activePart = this.props.childItem && this.props.childItem.part;
    if (activePart.filtersReceived) {
      this.setState({
        isLoading: false,
      })
    } else {
      this.setState({
        isLoading: true
      });
      this.checkIfAllFiltersReceived(activePart, this.props.allFilterGroups)
        .then(() => {
          if (this._isMounted) {
            this.setState({
              isLoading: false,
            })
          }
        });
    }
  }

  isFilterSelected = (filter) => findIndex(this.props.selectedFilters, {filterId:filter}) !== -1;
  isFilterExpanded = (filter) => arrayHasValue(this.props.expandedFilters, filter);

  handleExpandFilter = (filter) => Analytics.sendClickEvent('filter-expand-' + filter) && this.props.setExpandedFilters(toggleArrayValue([...this.props.expandedFilters], filter));
  handleSelectFilter = (filterId, filterGroupId) => Analytics.sendClickEvent('filter-selected-' + filterId) &&  this.props.setSelectedFilters(toggleFilterArrayValue([...this.props.selectedFilters],
    {filterId, filterGroupId}));

  handleGroupClick = (filterName) => {
    Analytics.sendClickEvent('show-filter-group-' + filterName);
    if (this.props.filterVisible === filterName) {
      this.props.showFilters(false);
    } else {
      this.props.setFilterVisible(filterName);
      this.setAvailableFiltersValues(this.props, filterName);
    }
  };

  handleReset = () => {
    this.props.setSelectedFilters([]);
    this.props.setExpandedFilters([]);
    this.props.handleSearchInputChange({target: {value: ''}});
  };

  render() {
    const activePart = this.props.childItem.part;
    return (
      <Fragment>
        <div className="filters-header">
          {this.state.filterButtons.map((filterName) => {
            const filterGroup = this.props.allFilterGroups.find(group => group.name === filterName);
            const buttonText = (filterName === "Others") ? "+Filters" : filterName;
            const filterNameLowerCased = filterName.toLowerCase();
            let buttonEnabled = false;
            if (filterName === "Others") {
              buttonEnabled = Array.isArray(activePart.filtersReceived) && this.props.allFilterGroups.some(filterGroup => {
                return !["Materials", "Brand", "Color"].includes(filterGroup.name) && filterGroup.values.some(filterValue => {
                  return activePart.filtersReceived.includes(filterValue.id);
                })
              });
            } else {
              buttonEnabled = filterGroup && (Array.isArray(activePart.filtersReceived) && filterGroup.values.some(filterValue => {
                return activePart.filtersReceived.includes(filterValue.id);
              }));
            }
            return (
              <div key={filterName}
                   onClick={() => this.handleGroupClick(filterName)}
                   className={"filters-header-icon filters-header-icon--"+filterNameLowerCased
                   + (this.props.filterVisible === filterName ? " filters-header-icon--active filters-header-icon--active--"+filterNameLowerCased : "")
                   + (!buttonEnabled ? " filters-header-icon--disabled" : "")}>
                <FormattedMessage id={buttonText}/>
              </div>
            )
          })}
          <FiltersSearch handleSearchInputChange={this.props.handleSearchInputChange} searchText={this.props.searchText}/>
          <div className="filters-header-icon filters-header-icon--reset" onClick={this.handleReset}>
            <span className="filters-header-icon--reset-title">
              <FormattedMessage id="filterSelection.reset"/>
            </span>
          </div>
        </div>
        {this.state.isLoading || !activePart.filtersReceived
          ? <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
          : <div className="filters-body">{this.renderFiltersBody()}</div>
        }
      </Fragment>
    )
  }

  renderFiltersBody = () => {
    const activePart = this.props.childItem.part;
    switch (this.props.filterVisible) {
      case "Others": {
        const otherFilterGroups = this.props.allFilterGroups.filter(filterGroup => {
          return !["Materials", "Brand", "Color"].includes(filterGroup.name) && filterGroup.values.some(filterValue => {
            return activePart.filtersReceived.includes(filterValue.id);
          })
        });
        const availableOtherFilterGroups = otherFilterGroups.map(fg => {
          return {
            id: fg.id,
            displayText: fg.name,
            items: fg.values.filter(filterValue => activePart.filtersReceived.includes(filterValue.id)),
          }
        });
        return this.renderGenericFilters(availableOtherFilterGroups, true);
      }
      case "Materials": {
        const filterGroup = this.props.allFilterGroups.find(group => group.name === "Materials");
        if (this.checkFilterGroupForAvailableFilterValues(filterGroup).length) {
          return this.renderGenericFilters(filterGroup.values, false, filterGroup.id);
        }
        break;
      }
      case "Brand": {
        const filterGroup = this.props.allFilterGroups.find(group => group.name === "Brand");
        if (this.checkFilterGroupForAvailableFilterValues(filterGroup).length) {
          return this.renderBrand(filterGroup);
        }
        break;
      }
      case "Color": {
        const filterGroup = this.props.allFilterGroups.find(group => group.name === "Color");
        if (this.checkFilterGroupForAvailableFilterValues(filterGroup).length) {
          return this.renderColor(filterGroup);
        }
        break;
      }
    }
    return null;
  };

  checkFilterGroupForAvailableFilterValues = (filterGroup) => {
    if (!filterGroup || !filterGroup.values) {
      return []
    }
    const activePart = this.props.childItem.part;
    return filterGroup.values.filter(filterValue => {
      return activePart.filtersReceived.includes(filterValue.id);
    })
  };

  /**
   *
   * @param filterList {Array}
   * @param groupsFirst {boolean}
   * @param groupId {any}
   * @return {*}
   */
  renderGenericFilters = (filterList, groupsFirst = false, groupId) => {
    // console.log('filterList', filterList);
    const fabricatorData = this.props.fabricatorData;
    let filterOptions = filterList
      .filter(f => !(fabricatorData && ((f.value === "Slab" && fabricatorData.isRebath)
        || (f.value === "DuraBath Natural Stone" && !fabricatorData.isRebath)
      )))
      .map(f => {
        const sortedItems = (f.displayText === "Size")
          ? f.items.sort((a, b) => {
            const name1 = +a.value.split("X")[0].split("in")[0];
            const name2 = +b.value.split("X")[0].split("in")[0];
            return name1 !== name2 ? name1 < name2 ? -1 : 1 : 0
          })
          : f.items;
        let items = sortedItems.map(i => {
          return (
            <li className={"filters-body-item-expand-item"} key={i.id}>
              <CheckBox
                text={this.props.intl.formatMessage({id: (i.displayText || "").trim()})}
                checked={this.isFilterSelected(i.id)}
                onChecked={() => this.handleSelectFilter(i.id, groupId || f.id)}/>
            </li>
          );
        });

        return (
          <li className="filters-body-item" key={f.id}>
            <CheckBox
              text={this.props.intl.formatMessage({id: (f.displayText || "").trim()})}
              checked={this.isFilterSelected(f.id)}
              textOnly={groupsFirst}
              onChecked={() => this.handleSelectFilter(f.id, groupId || f.id)}/>

            {(f.items && f.items.length > 0)
              ? <span className={"filters-body-item-expand" + (this.isFilterExpanded(f.id) ? " filters-body-item-expand--expanded" : "")}
                      onClick={() => this.handleExpandFilter(f.id)} />
              : null}
            <ul className={"filters-body-item-expand-items" + (this.isFilterExpanded(f.id) ? " filters-body-item-expand-items--visible" : "")}>
              {items}
            </ul>
          </li>
        );
      });

    return (
      <div className="filters-body--others">
        <ul className="filters-body-items filters-body--others-container">
          {filterOptions}
        </ul>
      </div>
    );
  };

  renderBrand = (brandFilterGroup) => {
    return (
      <div className="filters-body--brand">
        <ul className="filters-body-items filters-body--brand-container">
          {this.checkFilterGroupForAvailableFilterValues(brandFilterGroup).map(f => (
            <li key={f.id}
                className={"filters-body-item filters-body--brand-item"
                + (this.isFilterSelected(f.id) ? " filters-body--brand-item--selected" : "")}
                style={{backgroundImage: `url(https://s3.amazonaws.com/filter-images/${f.icon})`}}
                onClick={() => this.handleSelectFilter(f.id, brandFilterGroup.id)}>
              {f.icon ? null : f.displayText}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  renderColor = (colorFilterGroup) => {
    return (
      <div className="filters-body--color">
        <ul className="filters-body-items filters-body--color-container">
          {this.checkFilterGroupForAvailableFilterValues(colorFilterGroup).map(f => (
            <li className="filters-body-item filters-body--color-item" key={f.id}>
              <CheckBox
                checked={this.isFilterSelected(f.id)}
                onChecked={() => this.handleSelectFilter(f.id, colorFilterGroup.id)}
                text={f.displayText}/>
              <span className="filters-body--color-item-preview" style={{backgroundColor: f.value}}/>
            </li>
          ))}
        </ul>
      </div>
    );
  };
}

const mapStateToProps = (store) => {
  return {
    selectedFilters: store.filterState.selectedFilters,
    expandedFilters: store.filterState.expandedFilters,
    filterVisible: store.filterState.filterVisible,
    fabricatorData: store.fabricatorState,
    allFilterGroups: store.filterState.filterGroups,
  };
};

const mapDispatchToProps = {
  setSelectedFilters,
  setExpandedFilters,
  showFilters,
  setFilterVisible,
};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FiltersBody)
);
